(()=>{'use strict';
const init=()=>{
 const header=document.querySelector('[data-site-header]');
 if(header){const update=()=>header.classList.toggle('is-scrolled',window.scrollY>50);update();window.addEventListener('scroll',update,{passive:true})}
 const hero=document.querySelector('[data-luxe-hero]');
 if(hero && window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
   let raf=0;
   hero.addEventListener('pointermove',e=>{
     if(raf)return;
     raf=requestAnimationFrame(()=>{raf=0;const b=hero.getBoundingClientRect(),x=(e.clientX-b.left)/b.width-.5,y=(e.clientY-b.top)/b.height-.5;hero.style.setProperty('--hero-x',(-x*18).toFixed(1)+'px');hero.style.setProperty('--hero-y',(-y*13).toFixed(1)+'px')});
   },{passive:true});
   hero.addEventListener('pointerleave',()=>{hero.style.setProperty('--hero-x','0px');hero.style.setProperty('--hero-y','0px')});
 }
 const buyForm=document.querySelector('[data-velochi-quick-buy]');
 const toast=document.querySelector('[data-velochi-cart-toast]');
 const countEls=document.querySelectorAll('.v-cart-count');
 let focusBefore=null;
 const closeToast=()=>{if(!toast)return;toast.classList.remove('is-active');toast.setAttribute('aria-hidden','true');document.body.style.overflow='';focusBefore?.focus?.()};
 const openToast=(item)=>{
   if(!toast)return;
   focusBefore=document.activeElement;
   const label=toast.querySelector('[data-toast-product]'),photo=toast.querySelector('[data-toast-photo]'),amount=toast.querySelector('[data-toast-price]');
   if(label)label.textContent=item.product_title||'Your selection';
   if(photo && item.image){photo.src=item.image;photo.alt=item.product_title||'Velochi product'} else if(photo)photo.style.display='none';
   if(amount){const amt=(item.final_price??item.price??0)/100;amount.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format(amt)}
   toast.classList.add('is-active');toast.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';
   toast.querySelector('[data-toast-close]')?.focus();
 };
 document.querySelectorAll('[data-toast-close],[data-toast-shade]').forEach(el=>el.addEventListener('click',closeToast));
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&toast?.classList.contains('is-active'))closeToast()});
 if(buyForm){
  buyForm.addEventListener('submit',async e=>{
   if(!window.fetch)return;
   e.preventDefault();const btn=buyForm.querySelector('button[type=submit]');const original=btn?.innerHTML;const error=buyForm.querySelector('[data-buy-error]');
   if(error)error.textContent='';
   if(btn){btn.disabled=true;btn.textContent='ADDING TO BAG…'}
   try{
     const res=await fetch(buyForm.action,{method:'POST',body:new FormData(buyForm),headers:{Accept:'application/json'}});
     const data=await res.json();
     if(!res.ok)throw new Error(data.description||data.message||'This item could not be added.');
     const cart=await fetch((window.Shopify?.routes?.root||'/')+'cart.js').then(r=>r.json());
     countEls.forEach(el=>el.textContent=String(cart.item_count||0));
     openToast(data);
   }catch(err){if(error)error.textContent=err.message||'Unable to add product. Please try again.';else window.location.assign('/cart')}
   finally{if(btn){btn.disabled=false;btn.innerHTML=original}}
  });
 }
 document.querySelector('[data-product-sticky-buy]')?.addEventListener('click',()=>{
   const btn=document.querySelector('#VelochiProductForm button[name="add"]');
   if(btn){btn.scrollIntoView({behavior:'smooth',block:'center'});btn.focus({preventScroll:true})}
 });
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();